module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	fox.registerWidget('Site_Layout', {
		configure: function(options) {
			this.registerOptions('', {
				autoRender: true,
				active: false,
				pageContainer: '#container',
				dontReuseSnByHash: true,
				'widgetGroupInfo.pages.manualActivation': true
			});

			this._active = false;

			this.callParent('configure', arguments);
		},

		init: function() {
			if (!this.getOption('template')) {
				this.setOption('template', this._widgetClass);
			}

			this.registerOptions('.Site_Page', {'embed.container': this.getPageContainer()});

			this.callParent('init', arguments);
		},

		activating: function() {
			fox.site.layout = {
				widget: this,
				alias: this.alias,
				info: {}
			};

			return this.callParent('activating', arguments);
		},

		runPage: function() {
			var cp = fox.site.getCurrentPage();
			this.getParent().switchEmbeddedWidget(this.alias);

			fox.site.page = {
				widget: this.rwom1('#' + cp.alias),
				alias: cp.alias,
				info: this.getOption('widgets.' + cp.alias)
			};

			var page = this.rwom1('#' + cp.alias);
			page._prepare();
			page.runPage();
		},

		getPageContainer: function() {
			return this.getOption('pageContainer');
		}
	});
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/site/layout.js
// module id = 222
// module chunks = 0